export default __webpack_public_path__ + "static/media/5 - Стойки с картами линий.16d19bd2.jpg";